import { createApp } from 'vue'
import StafetProfileForm from './StafetProfileForm'

const el = '.kb-component--stafet-profile-form'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetProfileFormDOM) => {
            const externalData = StafetProfileFormDOM.dataset.external
                ? JSON.parse(StafetProfileFormDOM.dataset.external)
                : null
            const props = {
                stafetId: externalData.stafetId ?? null,
                userData: externalData.userData ?? {},
                editProfileLink:
                    StafetProfileFormDOM.dataset.editProfileLink ?? null,
                removeProfileLink:
                    StafetProfileFormDOM.dataset.removeProfileLink ?? null,
                editPasswordLink:
                    StafetProfileFormDOM.dataset.editPasswordLink ?? null
            }
            const component = createApp(StafetProfileForm, props).use(Store)
            component.mount(StafetProfileFormDOM)
        })
    }
}
